import { render, staticRenderFns } from "./InviteToSchool.vue?vue&type=template&id=7a2ae889&"
import script from "./InviteToSchool.vue?vue&type=script&lang=js&"
export * from "./InviteToSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports